import { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import icoback from '../img/ico-back.svg';
import icobackblue from '../img/ico-backblue.svg';
import icosearch from '../img/ico-search.svg';
import icoclose from '../img/ico-close.svg';
import strings from '../strings.js'
import SongCard from '../SongCard';
import SelectingYesNoCard from '../SelectingYesNoCard';
import heart from '../img/heart.svg';
import noheart from '../img/noheart.svg';
import { SendMessage } from '../App.js';
import useSongSearch from '../useSongSearch';
import homeLogoBg from '../img2026/homeLogoBg.jpg';

const API_URL = "https://www.starboxkod.com/api";

const song1 = {
    "song_num": 110108,
    "song_name": "给我多一点",
    "singer": "SHE",
    "language": "国语",
    "server_id": "C",
    "rel_path": "05\\110108"
}



export function Rec({cookieFavs, setCookieFavs, setSelectedSinger, stateVer, lang, stateRec, tableNo, downloadingInProgress, setDownloadingInProgress}) {

    const [pageNumber, setPageNumber] = useState(0);




    const {
        loading,
        error,
        songs,
        hasMore
    } = useSongSearch(stateRec, pageNumber)

    const lookup = Object.fromEntries(songs.map(o => [o.song_num, o]));


    const [selectingYesNo, setSelectingYesNo] = useState(false);
    const [selectingYesNoSong, setSelectingYesNoSong] = useState({});
    function nowSelectSong ({ song }) {
        return;
        
        setSelectingYesNo(true);
        setSelectingYesNoSong(song);
    }


    
    const navigate = useNavigate()

    return (<>
    <div className="heatder purple" >
        <a onClick={(e) => {e.preventDefault();  navigate(-1)}}>
        <img
            src={icoback}
            alt="home"
        />
        </a>
        <div className = "headerReplaceText">{lang ? strings.cn.rec : strings.en.rec}</div>
        <div className = "headerEndText">{stateRec == "" ? [].length : stateRec.split(',').length}</div>


    </div>


    <div className="song-container" id="song-container" style={{marginTop: "4rem"}}>
    {!loading && stateRec != ""
        ? (
            <>
                {stateRec.split(',').map((song_num, index) => {
                    if (lookup[song_num] != null) {
                        return <SongCard setSelectedSinger={setSelectedSinger}  Rec={true} List={stateVer==="wangluo"} tableNo={tableNo} lang={lang} index={index} song={lookup[song_num]} key={lookup[song_num].song_num} stateVer={stateVer} downloadingInProgress={downloadingInProgress} setDownloadingInProgress={setDownloadingInProgress}/>  
                    }
                })}     
            </>
        ) :
        (
            <div className="empty">
                <h2>No songs found</h2>
            </div>
        )}
    </div>

    {loading && 'Loading...'}
    {error && 'Error...'}

    { selectingYesNo && (
        <>
        <SelectingYesNoCard cookieFavs={cookieFavs} setCookieFavs={setCookieFavs} song={selectingYesNoSong} onClick={() => { setSelectingYesNo(false);}} tableNo={tableNo} lang={lang} stateVer={stateVer}/>
        </>
    )}
    
</>)}
